function formatDateDurationForJoinedDate(dateString) {
  const originalDate = new Date(dateString);

  const options = { year: "numeric", month: "long" };
  const formattedDate = originalDate.toLocaleDateString("en-US", options);
  return formattedDate;
}

function formatDateDurationForJoinedDateExtended(dateString, addTime = true) {
  const originalDate = new Date(dateString);

  // Get day, month, and year separately
  const day = originalDate.getDate();
  const month = originalDate.toLocaleString("en-US", { month: "long" });
  const year = originalDate.getFullYear();

  // Get hours and minutes separately
  const hours = originalDate.getHours();
  const minutes = originalDate.getMinutes();

  // Determine the suffix for the day (e.g., 'th', 'st', 'nd', 'rd')
  const daySuffix = getDaySuffix(day);

  // Format the date string
  let formattedDate = `${day}${daySuffix} ${month} ${year}`;

  if (addTime) {
    formattedDate = `${formattedDate}, ${formatTime(hours, minutes)}`;
  }

  return formattedDate;
}

// Helper function to determine the day suffix
function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
    return "th";
  }
  const lastDigit = day % 10;
  switch (lastDigit) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
}

// Helper function to format time with AM/PM
function formatTime(hours, minutes) {
  const amPm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${formattedHours}:${formattedMinutes} ${amPm}`;
}

export {
  formatDateDurationForJoinedDate,
  formatDateDurationForJoinedDateExtended,
};
